<ppl-accordion [title]="'Sick Time Summary'" [isOpen]="true">

  <div class="">
    <div class="">
      <!-- <form nz-form [formGroup]="searchForm">
        <nz-row [nzGutter]="16">
          <nz-col nzSpan="6" [nzXs]="24" [nzSm]="12" [nzMd]="12" [nzLg]="6" [nzXl]="6" [nzXXl]="6">
            <nz-form-item>
              <nz-form-label [nzXs]="24" [nzSm]="8" class="ppl-form-label">Date Range</nz-form-label>
              <nz-form-control [nzXs]="24" [nzSm]="16">
                <nz-range-picker formControlName="dateRange" style="width: 100%;" nzAllowClear></nz-range-picker>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="4" [nzXs]="24" [nzSm]="12" [nzMd]="8" [nzLg]="4" [nzXl]="4" [nzXXl]="4">
            <nz-form-item>
              <nz-form-label [nzXs]="24" [nzSm]="8" class="ppl-form-label">Provider</nz-form-label>
              <nz-form-control [nzXs]="24" [nzSm]="16" [nzErrorTip]="'Please select an provider'">
                <nz-select formControlName="employer" class="ppl-select filters" id="employer" nzPlaceHolder="Provider" nzShowSearch nzAllowClear style="width: 100%;">
                  @for(emp of employers; track $index){
                  <nz-option [nzLabel]="emp?.providerName || null" [nzValue]="emp.providerId"></nz-option>
                  }
                </nz-select>
              </nz-form-control>
            </nz-form-item>
          </nz-col>
          <nz-col nzSpan="" [nzXs]="12" [nzSm]="12" [nzMd]="12" [nzLg]="5" [nzXl]="4" [nzXXl]="4">
            <div class="timesheet-action-buttons" style="display: flex; gap: 8px;">
              <ppl-button label="Search" icon="fa fa-filter" [customClass]="'primary-button'"
                [iconPosition]="'left'" (click)="filterBalanceSearch()"
                *authorize="[pageId, tabId, 'AddTimeenties', 'section', 'read']"></ppl-button>
              <ppl-button label="" ariaLabel="Refresh" icon="fa fa-refresh" [customClass]="'primary-button'"
                [iconPosition]="'left'" (click)="loadBalancesData()"></ppl-button>
            </div>
          </nz-col>
        </nz-row>
      </form> -->
    </div>
  </div>

    <ppl-list-table
      [cols]="tableColumns"
      [formTable]="true"
      [formRows]="formRows"
      [disableSelection]="true"
      [disableSearch]="true"
      [disableSort]="true"
      [showCustomSearch]="false"
      [showColumnFilters]="false"
      [pagination]="false"
      [enableActions]="false"
      [enableMobileView]="true"
      [tableScrollable]="true"
      tableScrollHeight="400px">

      <ng-template #rowActions let-rowIndex="rowIndex">
        <!-- Actions column placeholder -->
      </ng-template>
    </ppl-list-table>
</ppl-accordion>